import styled from '@emotion/styled';

import { Card } from '@app/components/Card/Card';
import { tabletLandscape } from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

export const GiftCardStyled = styled(Card)`
  min-width: ${rem(140)};
  box-sizing: border-box;
  flex: 0 0 30%;
  position: relative;

  @media (max-width: ${tabletLandscape}) {
    flex: 0 0 48%;
  }
`;
